<template>
  <pre
    v-if="isDev"
    class="border-base-300 bg-base-200 overflow-x-auto rounded-xl border p-4"
    >{{ error.stack }}</pre
  >
</template>

<script setup lang="ts">
import type { NuxtError } from "#app";

defineProps<{ error: NuxtError }>();
const isDev = import.meta.dev;
</script>

<style scoped></style>
